import { graphqlClient } from '@/lib/graphql-client';
import { buildGetSkillCategoriesQuery } from '../graphql/queries';
import {
  DELETE_SKILL_CATEGORY_MUTATION,
  INSERT_SKILL_CATEGORY_MUTATION,
  UPDATE_SKILL_CATEGORY_MUTATION,
} from '../graphql/mutations';
import {
  GetSkillCategoriesParams,
  SkillCategoriesPagingResult,
  SkillCategoryInsertInput,
  SkillCategoryUpdateInput,
} from '../types/skill-category.types';

export const getSkillCategories = async (
  params: GetSkillCategoriesParams
): Promise<{ SkillCategorys: SkillCategoriesPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetSkillCategoriesQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ SkillCategorys: SkillCategoriesPagingResult }>;
};

export const createSkillCategory = async (input: SkillCategoryInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_SKILL_CATEGORY_MUTATION, variables: { input } });
};

export const updateSkillCategory = async (params: {
  itemId: string;
  input: SkillCategoryUpdateInput;
}) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_SKILL_CATEGORY_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteSkillCategory = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_SKILL_CATEGORY_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
